import {
  CHANNEL_GROUP_PREVIEW,
  CHANNEL_GROUP_NEW,
  CHANNEL_GROUP_UPDATE,
  CHANNEL_GROUP_REMOVE,
  CHANNEL_GROUP_PROCESS_SUCCESS,
  CHANNEL_GROUP_DATASOURCE_SUCCESS,
  CHANNEL_GROUP_SEARCH,
  CHANNEL_GROUP_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANNEL_GROUP_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case CHANNEL_GROUP_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case CHANNEL_GROUP_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case CHANNEL_GROUP_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case CHANNEL_GROUP_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case CHANNEL_GROUP_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case CHANNEL_GROUP_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case CHANNEL_GROUP_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}